/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_5_ProblemInputs */

const es_home_usecases_item_5_problem = /** @type {(inputs: Home_Usecases_Item_5_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se necesita encontrar documentación de auditoría o cumplimiento rápidamente.`)
};

const en_home_usecases_item_5_problem = /** @type {(inputs: Home_Usecases_Item_5_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit or compliance documentation needs to be found quickly.`)
};

/**
* | output |
* | --- |
* | "Audit or compliance documentation needs to be found quickly." |
*
* @param {Home_Usecases_Item_5_ProblemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_5_problem = /** @type {((inputs?: Home_Usecases_Item_5_ProblemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_5_ProblemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_5_problem(inputs)
	return en_home_usecases_item_5_problem(inputs)
});
export { home_usecases_item_5_problem as "home.usecases.item_5_problem" }